import React, { useState, useRef } from 'react';
import ProtectedRoute from '../../routes/protected';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Toast } from 'primereact/toast';
import { useNavigate, useLocation } from 'react-router-dom';
import FormRequestFeedback from '../../components/performance/forms/formRequestFeedback';


export default function FeedbackRequestPage() {
    const toast = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const preselected = location.state?.preselected || null;
    const [done, setDone] = useState(false);

    if (done) {
        return (
            <ProtectedRoute>
                <Toast ref={toast} position="top-right" />
                <div className="container py-5">
                    <div className="text-center">
                        <div style={{ fontSize: 80 }}>📩</div>
                        <h4 className="fw-bold mt-3">Solicitação enviada!</h4>
                        <p className="text-muted">Seu pedido de feedback foi enviado aos colaboradores.</p>
                        <div className="d-flex gap-2 justify-content-center mt-4">
                            <button className="btn btn-success btn-sm btn-rounded px-3" onClick={() => setDone(false)}>
                                Solicitar outro
                            </button>
                            <button className="btn btn-outline-secondary btn-sm btn-rounded px-3" onClick={() => navigate(-1)}>
                                Voltar
                            </button>
                        </div>
                    </div>
                </div>
            </ProtectedRoute>
        );
    }

    return (
        <ProtectedRoute>
            <Toast ref={toast} position="top-right" />

            <div className="container py-4 formMarginBottom" style={{ maxWidth: 640 }}>

                <div className="d-flex align-items-center gap-3 mb-4">
                    <button className="btn btn-link p-0 text-decoration-none text-muted" onClick={() => navigate(-1)}>
                        <FontAwesomeIcon icon={solid('arrow-left')} />
                    </button>
                    <div>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={solid('paper-plane')} className="me-2 text-green" />
                            Solicitar Feedback
                        </h4>
                        <p className="text-muted small mb-0">Peça feedback de um ou mais colegas sobre um tema específico</p>
                    </div>
                </div>

                <div className="card border-0 shadow-sm">
                    <div className="card-body p-4">
                        <FormRequestFeedback
                            onSuccess={() => setDone(true)}
                            onCancel={() => navigate(-1)}
                            preselected={preselected}
                        />
                    </div>
                </div>

            </div>
        </ProtectedRoute>
    );
}
